<template>
  <div class="container-fluid mt-7">
    <div class="card">
      <base-header class="pb-6" type="">
        <div class="row align-items-center py-4">
          <div class="col-lg-6 col-7">
            <h6 class="h2 d-inline-block mb-0">Scheduled Jobs</h6>
          </div>
        </div>
        <el-table class="table-responsive table liquibase-table custom-scheduledJobs" :data="tableData"
          :span-method="mergeRows" border :row-class-name="rowClassName" header-row-class-name="thead-light">
          <el-table-column label="Name" prop="name" min-width="150px">
            <template v-slot="{ row }">
              <div class="font-weight-600 name-column">{{ row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Description" prop="description" min-width="200px">
            <template v-slot="{ row }">
              <div class="description-text">{{ row.description }}</div>
            </template>
          </el-table-column>
          <el-table-column class="p-0" label="Jobs" prop="status" min-width="200px">
            <template v-slot="{ row }">
              <div class="description-text">{{ row.status }}</div>
            </template>
          </el-table-column>
        </el-table>
      </base-header>
    </div>
  </div>
</template>
<script>
import { ElTable, ElTableColumn } from "element-plus";
import cronstrue from "cronstrue";
export default {
  name: "scheduledTaskDetail",
  components: {
    [ElTable.name]: ElTable,
    [ElTableColumn.name]: ElTableColumn,
  },
  data() {
    return {
      tableData: [],
      descriptions: {
        "Get Portfolio": "This task calculates the PnL of each user at an interval of 30 seconds. If the PnL is greater than or equal to the allotted portfolio profit or loss percentage, it exits that position.",
        "Tick Delay Task": "This task will give alerts whenever the application fails to fetch a tick from the feeder for any particular instrument.",
        "Generate Pnl Report": "This task will show the top 5 profitable trades in Robo Telegram at the end of the day.",
        "User Retry": "This task retries session creation for users who failed on application startup.",
        "User Retry Stopped": "This task will provide an alert with the details of users who are logged in and those who failed to log in after retrying the session creation mechanism.",
        "Order Reconciliation": "This task will mark exits at the end of the day for orders that have no position but exist only in the database.",
        "Generate Order Report": "This task will generate the order report for the current date."
      }
    };
  },
  methods: {
    getScheduledTaskInfo(dataType) {
      const data = { type: dataType };
      this.$store
        .dispatch("techDashboardStore/getTechData", data, { root: true })
        .then((response) => {
          this.tableData = response.server.data.map((item) => {
            const match = JSON.parse(item.task).match(/\.([^.]+)$/);
            const taskName = match[1]
              .replace(/([a-z])([A-Z])/g, "$1 $2")
              .replace(/^./, (str) => str.toUpperCase());

            return {
              name: taskName,
              status: cronstrue.toString(JSON.parse(item.expression)),
              description: this.descriptions[taskName] || "No description available",
            };
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mergeRows({ row, column, rowIndex, columnIndex }) {
      if (column.property === "name" || column.property === "description") {
        const currentValue = row[column.property];
        const previousValue = this.tableData[rowIndex - 1]?.[column.property];
        if (rowIndex === 0 || currentValue !== previousValue) {
          let count = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i][column.property] === currentValue) {
              count++;
            } else {
              break;
            }
          }
          return { rowspan: count, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 1 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
  },
  mounted() {
    this.getScheduledTaskInfo("SCHEDULED_JOBS");
  },
};
</script>
<style></style>
